"use client"
import React, { useRef } from "react"
import { Toaster } from "react-hot-toast"
import { Provider } from "react-redux"
import { AppStore, makeStore } from "./Global"

interface StoreProviderProps {
    children: React.ReactNode
}

const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
    const storeRef = useRef<AppStore | null>(null)

    React.useEffect(() => {
        // Ensure scroll restoration is only set on the client side
        if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual"
        }
    }, [])

    if (!storeRef.current) {
        storeRef.current = makeStore()
        // If you have an action like initializeCount, dispatch it here:
        // storeRef.current.dispatch(initializeCount(count));
    }

    return (
        <Provider store={storeRef.current}>
            <Toaster />
            {children}
        </Provider>
    )
}

export default StoreProvider
